export default {"src":"/uk/_next/static/media/plaid.5417b89a.svg","height":48,"width":126,"blurWidth":0,"blurHeight":0};